<template>
    <div class="bindwx" v-if="visible">
        <template>
            <div class="content">


                <template v-if="loginType == 'wx'">
                    <div>
                        <div class="title">
                            <template v-if="data.welcomeFlag == 1">
                                <div>{{ data.welcomeText }}</div>
                            </template>
                            <template v-else>
                                <div>
                                    打开手机，扫一扫下方二维码，添加讲师企业微信
                                </div>
                            </template>
                        </div>
                        <div class="code">
                            <img :src="data.contactMeQcCode" alt="">
                        </div>
                        <div class="label">
                            <ol>
                                <li>打开手机扫描上方二维码</li>
                                <li>在弹出的菜单里选择-打开对方的企业微信名片</li>
                                <li>划到底部点击-添加到通讯录</li>
                            </ol>
                            <button class="btn" @click="refreshCode">没有显示二维码？点击刷新</button>
                        </div>
                    </div>
                </template>

                <template v-else>
                    <div class="label">
                        <div>当前链接需要验证微信好友关系,请点击退出，使用微信扫码登录</div>
                        <button class="btn" @click="loginOut">退出</button>
                    </div>
                </template>

                <template v-if="data.notFriendWatchFlag == 0">
                    <i class="el-icon-close close" @click="close"></i>
                </template>

            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: "bindWxUser",
    props: ['visible', 'initData'],
    data() {
        return {
            loginType: localStorage.getItem('login_Type'),
            time: null,
            data: {},
        }
    },

    mounted() {
        this.data = this.initData ? this.initData : {}
        clearInterval(this.time)
    },

    methods: {
        refreshCode() {
            var params = JSON.parse(localStorage.getItem('bind_wxuser'))
            this.$api.bindLiveWxUser(params.enterpriseCode, params.openId, params.unionId, params.subjectType).then(res => {
                this.data = res.data.data
            })
        },

        loginOut() {
            localStorage.removeItem('user_token_' + localStorage.getItem(this.$route.params.id+'c_id'))
            localStorage.removeItem('user_name')
            localStorage.removeItem('user_headimg')
            this.$message({
                message: '退出成功',
                type: 'success'
            })
            setTimeout(() => {
                window.location.reload()
            }, 1500);
        },

        checkBindWx() {
            if (this.loginType == 'wx') {
                var params = JSON.parse(localStorage.getItem('bind_wxuser'))
                this.time = setInterval(() => {
                    this.$api.bindLiveWxUser(params.enterpriseCode, params.openId, params.unionId, params.subjectType).then(res => {
                        if (res.data.data.friendFlag == 1) {
                            clearInterval(this.time)
                            setTimeout(() => {
                                window.location.reload()
                            }, 200)
                        }
                    })
                }, 3000)
            }
        },

        close() {
            this.$emit('close')
        }
    },
}
</script>

<style lang="scss" scoped>
.bindwx {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.1500);
    z-index: 99;

    .content {
        width: 392px;
        height: auto;
        box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.1500);
        border-radius: 5px;
        background-color: #fff;
        margin: auto;
        position: relative;
        top: 50%;
        transform: translate(0, -50%);
        box-sizing: border-box;
        padding: 45px 80px;

        .label {
            & ol {
                text-align: left;
                transform: translate(14px, 0);
            }

            & li {
                margin-bottom: 10px;
            }
        }

        .btn {
            border: none;
            width: 100%;
            line-height: 50px;
            border-radius: 10px;
            margin-top: 20px;

        }

        .close {
            position: absolute;
            top: 20px;
            right: 20px;
            font-size: 20px;
        }
    }

    img {
        width: 232px;
        height: 232px;
        margin: 30px 0;
    }
}
</style>